/**
 * @generated SignedSource<<6a93a3da7046b3e90a533adba461ec04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "NetworkFragments_allNetworkDropdown",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Network",
  "abstractKey": null
};

node.hash = "3a8700865bb47f2e5ca80c1c469ba791";

export default node;
